import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePagePreloader = defineStore('page_preloader', () => {
  const visible = ref(true)

  const setVisible = (value: boolean) => {
    visible.value = value
  }

  return {
    visible,

    setVisible,
  }
})
